import ajax from '@/utils/ajax'

/**
 * @module 能链直供系统
 */

// 获取能链直供系统token
export const getChainToken = params => ajax.post('login/supplyToken', params)

// 获取是否展示能链直供系统入口
export const getShowSupply = params => ajax.post('login/showSupply', params)